import type { FunctionComponent } from "react";
import { Button } from "@kanda-libs/ks-design-library";
import useAddCompanyRiskStatusButton from "./useAddCompanyRiskStatusButton";
import Modal from "./Modal";
import { Form, StringIndexedObject } from "@kanda-libs/ks-component-ts";
import FlagForm from "./FlagForm";

const AddCompanyRiskStatusButton: FunctionComponent = function () {
  const { form, onSubmit, onShowModal, isLoading } =
    useAddCompanyRiskStatusButton();

  return (
    <span>
      <Button.Text
        variant="outline"
        className="w-auto mt-2"
        id="add-company-risk-status-button"
        label="Add flag"
        onClick={() => {
          onShowModal();
        }}
      />
      <Modal>
        <Form
          id="add-company-risk-flag-form"
          form={form}
          onSubmit={
            onSubmit as (
              data: StringIndexedObject,
              event?: React.BaseSyntheticEvent
            ) => void
          }
        >
          <FlagForm isLoading={isLoading} />
        </Form>
      </Modal>
    </span>
  );
};

export default AddCompanyRiskStatusButton;
